import React, { Component } from 'react';
//import Coin from '../../assets/images/coin.png';
import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    EmailShareButton,
    EmailIcon,
    TwitterIcon,
    WhatsappIcon,
    WhatsappShareButton,
    TelegramIcon,
    TelegramShareButton,
} from "react-share";

const img_path = 'https://www.kinshipliving.com/images/uploads/kinship/users/';



export default class ReferralPage extends Component {
    // constructor() {
    //     super();
    // }

    CopyText = () => {
        //  alert('jjj')
        var copyText = document.getElementById("code");

        /* Select the text field */
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */

        /* Copy the text inside the text field */
        navigator.clipboard.writeText(copyText.value);

        /* Alert the copied text */
        // alert("Copied the text: " + copyText.value);
    }

    render() {
        return (
            <div className='refer-main'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-12 col-sm-12 col-md-4 col-lg-4'>
                            <div className='card profile-div-main'>
                                <div className='col-12'>

                                    <div className='profile-img-div'>
                                        <div className='profile-img'>
                                            <img src={img_path + localStorage.getItem('current_user_pic').replace(',', '')} alt='loading...' />
                                        </div>
                                        <div className='profile-name'>
                                            <h4>{localStorage.getItem('current_user_full_name')}</h4>
                                        </div>
                                    </div>



                                </div>
                                {/*
                                <div className='col-12'>

                                    <div className='points-div'>
                                        <div className='coin-img'>
                                            <img src={Coin} alt="loading..." />
                                        </div>
                                        <div className='points'>
                                            <h4>20</h4>
                                            <h6>Credits Left</h6>
                                        </div>
                                    </div>

                                </div>
                                */ }

                                <ul className="nav flex-column mb-0">
                                    {/* <li className="nav-item sidebar-list">
                                        <a href='/' className='nav-link sidebar-items profile-items active'
                                            id="home"
                                            data-toggle="tab"
                                            role="tab"
                                        //  onClick={()=>this.HandleRouting('home')}
                                        >
                                            <i class='fa fa-shopping-cart profile-card-icons'></i>
                                            Buy Credits
                                        </a>

                                    </li>
                            */}
                                    <li className="nav-item sidebar-list">
                                        <div className='profile-items-seperation'></div>
                                    </li>
                                    <li className="nav-item sidebar-list">
                                        <a href='/upcoming-events' className='nav-link sidebar-items profile-items'
                                            id="events"
                                            data-toggle="tab"
                                            role="tab"
                                            onClick={()=>this.props.HandleRouting('upcoming-sessions')}
                                        >
                                            <i class='fa fa-calendar-o profile-card-icons'></i>
                                            Booked Sessions
                                        </a>

                                    </li>
                                    <li className="nav-item sidebar-list">
                                        <a href='/classes' className='nav-link sidebar-items profile-items'
                                            id="classes"
                                            data-toggle="tab"
                                            role="tab"
                                          //  onClick={()=>this.props.HandleRouting('booked-events')}
                                        >
                                            <i class='fa fa-calendar-o profile-card-icons'></i>
                                            Booked Events
                                        </a>

                                    </li>

                                    {/*   <li className="nav-item sidebar-list">
                                        <a href='/travel' className='nav-link sidebar-items profile-items'
                                            id="travel"
                                            data-toggle="tab"
                                            role="tab"
                                        // onClick={()=>this.HandleRouting('travel')}
                                        >
                                            <i class='fa fa-calendar-o profile-card-icons'></i>
                                            Earned Rewards
                                        </a>

                                    </li>
                                    <li className="nav-item sidebar-list">
                                        <a href='/all-games' className='nav-link sidebar-items profile-items'
                                            id="games"
                                            data-toggle="tab"
                                            role="tab"
                                            onClick={() => this.HandleRouting('all-games')}
                                        >
                                            <i class='fa fa-calendar-o profile-card-icons'></i>
                                            Payment History
                                        </a>

                                    </li>
                                    <li className="nav-item sidebar-list">
                                        <div className='profile-items-seperation'></div>
                                    </li>
                        */}
                                    <li className="nav-item sidebar-list">
                                        <a href='/all-games' className='nav-link sidebar-items profile-items'
                                            id="games"
                                            data-toggle="tab"
                                            role="tab"
                                          //  onClick={() => this.HandleRouting('all-games')}
                                        >

                                            Help
                                        </a>

                                    </li>
                                    { /*  <li className="nav-item sidebar-list">
                                        <a href='/all-games' className='nav-link sidebar-items profile-items'
                                            id="games"
                                            data-toggle="tab"
                                            role="tab"
                                            onClick={() => this.HandleRouting('all-games')}
                                        >

                                            Privacy Policy
                                        </a>

                                    </li>
                                    <li className="nav-item sidebar-list">
                                        <a href='/all-games' className='nav-link sidebar-items profile-items'
                                            id="games"
                                            data-toggle="tab"
                                            role="tab"
                                            onClick={() => this.HandleRouting('all-games')}
                                        >

                                            Terms & Conditions
                                        </a>

                                    </li>
                    
                                    <li className="nav-item sidebar-list">
                                        <a href='/all-games' className='nav-link sidebar-items profile-items'
                                            id="games"
                                            data-toggle="tab"
                                            role="tab"
                                            onClick={() => this.HandleRouting('all-games')}
                                        >

                                            Logout
                                        </a>

                                    </li>
                    */}
                                </ul>
                            </div>
                        </div>
                        <div className='col-12 col-sm-12 col-md-8 col-lg-8'>
                            <div className='refer-earn-main'>
                                <div className='refer-head'>
                                    <h4>Refer & Earn</h4>
                                </div>
                                <div className='card card-body refer-earn-card'>
                                    <div className='row'>
                                        <div className='col-12 col-sm-6 col-md-12 col-lg-6'>
                                            <div className='refer-link-div'>
                                                <h4>Invite Your friends & earn free sessions</h4>
                                                <h5>Your Referral Link(Tap to copy)</h5>
                                                {sessionStorage.getItem('current_user_referral_code') !== '' && sessionStorage.getItem('current_user_referral_code') !== null && sessionStorage.getItem('current_user_referral_code') !== undefined ?
                                                    <div className='refer-link-code'>
                                                        <input type='text' disabled="true" className='referral-code-input' id="code" value={sessionStorage.getItem('current_user_referral_code')} />
                                                        <button type='button' className='btn' onClick={this.CopyText}>Copy</button>
                                                    </div>
                                                    : ''}
                                                <div style={{ textAlign: 'center', marginTop: '15px' }}>OR</div>
                                                {sessionStorage.getItem('current_user_referral_code') !== '' && sessionStorage.getItem('current_user_referral_code') !== null && sessionStorage.getItem('current_user_referral_code') !== undefined ?

                                                    <div className='refer-link-social-btn'>

                                                        <FacebookShareButton url={sessionStorage.getItem('current_user_referral_code')}>
                                                            <FacebookIcon size={44} round={true} ></FacebookIcon>
                                                        </FacebookShareButton>
                                                        <EmailShareButton url={sessionStorage.getItem('current_user_referral_code')}>
                                                            <EmailIcon size={44} round={true} ></EmailIcon>
                                                        </EmailShareButton>
                                                        <TwitterShareButton url={sessionStorage.getItem('current_user_referral_code')}>
                                                            <TwitterIcon size={44} round={true} ></TwitterIcon>
                                                        </TwitterShareButton>
                                                        <WhatsappShareButton url={sessionStorage.getItem('current_user_referral_code')}>
                                                            <WhatsappIcon size={44} round={true} ></WhatsappIcon>
                                                        </WhatsappShareButton>
                                                        <TelegramShareButton url={sessionStorage.getItem('current_user_referral_code')}>
                                                            <TelegramIcon size={44} round={true} ></TelegramIcon>
                                                        </TelegramShareButton>

                                                    </div>
                                                    : ''}
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-6 col-md-12 col-lg-6'>
                                            <div className='refer-how-work-div'>
                                                <h4>How it Works?</h4>
                                                <div className='refer-how-work-content'>
                                                    <div className='row'>
                                                        <div className='col-3 col-md-3 col-lg-3'>
                                                            <div className='refer-numbering'>
                                                                <p>1</p>
                                                            </div>
                                                            <div className='refer-vertical-line'>

                                                            </div>
                                                            <div className='refer-numbering'>
                                                                <p>2</p>
                                                            </div>
                                                            <div className='refer-vertical-line'>

                                                            </div>
                                                            <div className='refer-numbering'>
                                                                <p>3</p>
                                                            </div>

                                                        </div>
                                                        <div className='col-9 col-md-9 col-lg-9'>
                                                            <div className='refer-content'>
                                                                <p>Share the referral link with your friends.</p>
                                                            </div>
                                                            <div className='refer-content' style={{ marginTop: '40px' }}>
                                                                <p>Ask them to click on the link and sign up.</p>
                                                            </div>
                                                            <div className='refer-content' style={{ marginTop: '40px' }}>
                                                                <p>Receive 5 FREE SESSIONS for each friend who attends a session.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='terms-condition-div'>
                                                    <p onClick={()=>this.props.HandleRouting('terms-conditions')}>Terms & Conditions</p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className='rferrals-info'>
                                    <h4>Referrals</h4>
                                    <div className='referrals-count'>
                                        <h5>Total Referrals
                                                <span style={{marginLeft:'40px'}}>{this.props.mystate.referralCount}</span>  
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}


